module.exports = __webpack_public_path__ + "static/media/offerteaanvaard.b95f2fed.svg";